<script setup lang="ts">
import { useImage } from '@vueuse/core';
import { watch } from 'vue';

import type { AppImgType } from './AppImg.model';

interface AppImgProps {
  src: string;
  imgType?: AppImgType;
  alt?: string;
}

interface AppImgEmit {
  (eventName: 'img-load-error', src: string): void;
  (eventName: 'click'): void;
}

const props = withDefaults(defineProps<AppImgProps>(), {
  imgType: 'cover',
});
const emit = defineEmits<AppImgEmit>();

const { isLoading, error } = useImage({ src: props.src });

watch(error, () => {
  emit('img-load-error', props.src);
});
</script>

<template>
  <img
    v-if="!isLoading"
    :src="props.src"
    :alt="props.alt"
    :class="{
      img: true,
      [props.imgType]: props.imgType,
    }"
    @click="emit('click')"
  />
  <div
    v-else
    :class="{
      img: true,
      [props.imgType]: props.imgType,
    }"
  />
</template>

<style scoped lang="scss">
.img {
  &.cover {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &.contain {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  &.scaleX {
    height: 100%;
    width: auto;
  }
}
</style>
